import { useMemo } from 'react'

import { skipToken } from '@reduxjs/toolkit/query'

import { NpAppointmentType } from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { useGetNpSessionsQuery } from '../data/npSessionsApi'

// Only these sessions are offered for scheduling from the chart for now
const SCHEDULABLE_SESSION_TYPES = [
  NpAppointmentType.NP_CLINICAL_INTAKE,
  NpAppointmentType.NP_TESTING_SESSION_1,
  NpAppointmentType.NP_TESTING_SESSION_2,
]

// The NP sessions in the member's active episode that still have to be booked, in flow order.
export const useNpSessionsToSchedule = ({ clientId, isEnabled }: { clientId?: string; isEnabled: boolean }) => {
  const { currentData: data, isLoading } = useGetNpSessionsQuery(
    isEnabled && clientId ? { userLyraId: clientId } : skipToken,
  )

  const sessionTypes = useMemo(
    () =>
      (data?.sessions ?? [])
        .filter(({ sessionType, appointment }) => SCHEDULABLE_SESSION_TYPES.includes(sessionType) && !appointment)
        .sort((a, b) => a.sequence - b.sequence)
        .map(({ sessionType }) => sessionType),
    [data],
  )

  return { sessionTypes, isLoading }
}
